import React from "react";

type ImageTransitionBandProps = {
  image: string;
  text?: string;
  align?: "center" | "left";
};

export default function ImageTransitionBand({
  image,
  text,
  align = "center",
}: ImageTransitionBandProps) {
  return (
    <section
      className="relative w-full h-[260px] md:h-[300px] overflow-hidden"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Brand overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#07162E]/90 via-[#07162E]/70 to-[#0E6F7E]/60"></div>

      {/* Subtle texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.04),transparent_100%)]"></div>

      {/* Content */}
      {text && (
        <div
          className={`relative z-10 h-full flex items-center px-6 md:px-12 lg:px-24 ${
            align === "center" ? "justify-center text-center" : "justify-start"
          }`}
        >
          <div className="max-w-4xl">
            {/* <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mb-6"></div> */}
            <p className="text-white text-2xl md:text-2xl font-semibold leading-snug pt-10">
              {text}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
